import { logos } from '../../assets/logos';
import config from '../../utils/config';
import { Image, Root } from './header.styles';

const brand = config.brandKey;

export function Header() {
    return (
        <Root>
            <Image src={logos[brand]} alt="Logo" />
        </Root>
    );
}
